import { useEffect } from "react";

import { withAuthInfo, WithAuthInfoProps } from "@propelauth/react";
import { useSelector } from "react-redux";

import { selectActiveCompanyId } from "@/store/features/companies/companies";

import { authedFetch } from "./index";

export const AxiosInterceptorUpdater = withAuthInfo(
  ({ accessToken }: WithAuthInfoProps) => {
    const activeCompanyId = useSelector(selectActiveCompanyId);

    useEffect(() => {
      const requestInterceptor = authedFetch.interceptors.request.use(
        (config) => {
          if (accessToken) {
            // eslint-disable-next-line no-param-reassign
            config.headers.Authorization = `Bearer ${accessToken}`;
            return config;
          }
          return config;
        },
        (error: Error) => Promise.reject(error)
      );

      return () => {
        // On component unmount, remove this interceptor
        authedFetch.interceptors.request.eject(requestInterceptor);
      };
    }, [accessToken]); // Re-run when propelauth token changes

    // set x-company-id to activeCompanyId in headers
    useEffect(() => {
      const requestInterceptor = authedFetch.interceptors.request.use(
        (config) => {
          const LSactiveCompanyId = localStorage.getItem("activeCompanyId");
          if (activeCompanyId || LSactiveCompanyId) {
            // eslint-disable-next-line no-param-reassign
            config.headers["x-company-id"] =
              activeCompanyId || LSactiveCompanyId;
            return config;
          }
          return config;
        },
        (error: Error) => Promise.reject(error)
      );

      return () => {
        // On component unmount, remove this interceptor
        authedFetch.interceptors.request.eject(requestInterceptor);
      };
    }, [activeCompanyId]);
    return null;
  }
);
